var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import ngTranslate from 'angular-translate';
import { NgModule } from 'angular-ts-decorators';
import { LocaleModule, SUPPORTED_LANGUAGES_INJECTION_TOKEN } from '../locale/locale.module';
import { RevisionController } from './controllers/revision.controller';
import { SettingsService } from './services/settings.service';
import { de } from './lang/de';
import { en } from './lang/en';
import { es } from './lang/es';
import { fr } from './lang/fr';
import { it } from './lang/it';
let AdminSettingsModule = class AdminSettingsModule {
    // Minification-safe CI injections, everything @Inject()ed somewhere must be mentioned here:
    static $inject = ['$translateProvider', SUPPORTED_LANGUAGES_INJECTION_TOKEN];
    static config($translateProvider, SUPPORTED_LANGUAGES) {
        const LOCALES = { de, en, es, fr, it };
        for (const locale of SUPPORTED_LANGUAGES) {
            $translateProvider.translations(locale, LOCALES[locale] ?? {});
        }
    }
};
AdminSettingsModule = __decorate([
    NgModule({
        id: 'AdminSettingsModule',
        imports: [ngTranslate, LocaleModule],
        declarations: [RevisionController],
        providers: [SettingsService],
        bootstrap: [],
    })
], AdminSettingsModule);
export { AdminSettingsModule };
// Required, because we wanna use this controller via 'ng-controller="RevisionController as main" in our HTML,
// otherwise the controller is not known by name:
AdminSettingsModule.module.controller('RevisionController', RevisionController);
